var app = angular.module("leonardo");

var MyApprovalTaskListPaginated = function(
  $scope,
  $rootScope,
  $q,
  $filter,
  $attrs,
  $controller,
  $timeout,
  FilterService,
  TaskService,
  TemplateService,
  AuthDataService
) {

  $scope.reset_page = false;
  $scope.tasks = [];

  $scope.getClasses = function (task) {
    var classes = [];
    if (task && !isNull(task.priority)) {
      switch (task.priority.toString()) {
        case TemplateService.PRIORITY_CRITICAL:
          classes.push('priority-critical');
          break;
        case TemplateService.PRIORITY_NORMAL:
          classes.push('priority-normal');
          break;
        case TemplateService.PRIORITY_MINOR:
          classes.push('priority-minor');
          break;
      }
    }
    return classes;
  };

  $scope.getColor = function (task) {
    var color = 'primaryColor';
    if (task && !isNull(task.priority)) {
      switch (task.priority.toString()) {
        case TemplateService.PRIORITY_CRITICAL:
          color = 'errorColor';
          break;
        case TemplateService.PRIORITY_NORMAL:
          color = 'warningColor';
          break;
        case TemplateService.PRIORITY_MINOR:
          color = 'tertiaryColor';
          break;
      }
    }
    return color;
  };

  $scope.getParams = function (reset_page) {
    var params = {
      summary: true,
      account: FilterService.getFilter('account_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      property: FilterService.getFilter('property_reports'),
      managed_by: FilterService.getFilter('managed_by_reports'),
      category: FilterService.getFilter('category'),
      priority: FilterService.getFilter('priority'),
      approval_steps: FilterService.getFilter('approval_steps'),
      latest_submission_from: FilterService.getFilter('latest_submission_from'),
      latest_submission_to: FilterService.getFilter('latest_submission_to'),
      original_submission_from: FilterService.getFilter('original_submission_from'),
      original_submission_to: FilterService.getFilter('original_submission_to'),
      due_date_from: FilterService.getFilter('due_date_from'),
      due_date_to: FilterService.getFilter('due_date_to'),
      revision_number: FilterService.getFilter('revision_number'),
      active_approval_step_past_due: FilterService.hasFilter('not_past_due') ? Boolean(parseInt(FilterService.getFilter('not_past_due'))) : undefined,
      workflow: FilterService.getFilter('workflow'),
      submitted_by: FilterService.getFilter('submitted_by'),
      approver_ids: FilterService.getFilter('approver_ids'),
      order_by: $scope.order_by,
      keywords: FilterService.getFilter('keywords')
      // only_if_current_approver: FilterService.getFilter('current_approver'),
    };
    switch ($attrs.mode) {
      case 'review-pending':
        params['status'] = TaskService.STATUS_APPROVAL_IN_PROGRESS;
        break;
      case 'review-revision':
        params['status'] = TaskService.STATUS_APPROVAL_RETURN_SUBMITTER;
        break;
      case 'review-rejected':
        params['status'] = TaskService.STATUS_APPROVAL_REJECTED;
        break;
    }

    if (reset_page) {
      FilterService.setFilter('page', 1);
    }
    return params;
  };

  $scope.getBlockTasks = function (block, options, params, ordering, comparator) {
    let defer = $q.defer();
    let paramsTasks = params || $scope.getParams($scope.reset_page);
    let optionsTasks = angular.copy(options);
    angular.forEach(paramsTasks, function (value, key) {
      optionsTasks[key] = value;
    });
    TaskService.getTasklist(block, optionsTasks).then(function (data) {
      let results = data.results ? data.results : data;
      if (results.length > 0)
        $scope.$parent.$parent.loading = false;
      defer.resolve({data: data, results: results});
    }, function (error) {
      defer.reject(error);
    })
    .catch((error) => {
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();

    var params = {};
    $scope.tasks = [];
    switch ($attrs.mode) {
      case 'review-pending':
        params = $scope.getParams($scope.reset_page);
        $scope.getBlockTasks('my-approvals', options, params).then(function (data) {
          $scope.tasks = data.results;
          defer.resolve(data.data);
        }, function (error){
          handleError(error);
        });
        break;
      case 'review-revision':
        params = $scope.getParams($scope.reset_page);
        $scope.getBlockTasks('my-approvals', options, params).then(function (data) {
          $scope.tasks = data.results;
          defer.resolve(data.data);
        }, function (err){
          handleError(err);
        });
        break;
      case 'review-rejected':
        params = $scope.getParams($scope.reset_page);
        $scope.getBlockTasks('my-approvals', options, params).then(function (data) {
          $scope.tasks = data.results;
          defer.resolve(data.data);
        }, function (er){
          handleError(er);
        });
        break;
    }

    function handleError(error){
      if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
        $scope.tasks = [];
        defer.resolve({count: 0});
      }
    }

    $timeout(function () {
      $scope.init = true;
      $scope.reset_page = false;
    }, 1000);

    defer.promise.then(function(data){
      $rootScope.$broadcast('my-approvals-tasks:updated', $attrs.mode, data.count);
    });

    return defer.promise;
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.updateListTasks = function(task) {
    angular.forEach($scope.tasks, function(value){
      if (value.id === task.id) {
        $scope.loadPage($scope.page);
      }
    });
  };

  if (FilterService.initialized) {
    $scope.loadPage($scope.page);
  }
  else {
    $scope.$on('filter-service:initiated', function(){
      $scope.loadPage($scope.page);
    });
  }

  $scope.$watch('order_by', function (newValue, oldValue) {
    if (!angular.equals(newValue, oldValue)) {
      $scope.loadPage($scope.page);
    }
  })

  $scope.$on('filter-selection:updated', function() {
    if (FilterService.initialized) {
      $scope.reset_page = true;
    }
  });

  $scope.$on('task-status-date:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-recurrence-dialog:success', function(){
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-priority-dialog:success', function(){
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-deactivate-dialog:success', function(){
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-un-resolve-dialog:success', function(){
    $scope.loadPage($scope.page);
  });

  $scope.$on('task-assign-user:updated', function($event, task){
    $scope.updateListTasks(task);
  });

  $scope.$on('task-notes:updated', function($event, task){
    $scope.updateListTasks(task);
  });

  $scope.$on('template:updated', function($event, task){
    $timeout(function(){
    $scope.updateListTasks(task);
    }, 100);
  });

  $scope.$on('task-request-approval-dialog:success', function ($event, task) {
    updateSuccess(task);
  });

  $scope.$on('task-cannot-do-dialog:success', function ($event, task) {
    updateSuccess(task);
  });

  function updateSuccess(task) {
    if ($attrs.mode === 'review-pending') {
      $scope.loadPage($scope.page);
    }
    else {
      $scope.updateListTasks(task);
    }
  }

  $scope.$on('task-dynamic-form-data:updated', function($event, task){
    $scope.updateListTasks(task);
  });

};

app.controller('MyApprovalTaskListPaginated', [
  '$scope',
  '$rootScope',
  '$q',
  '$filter',
  '$attrs',
  '$controller',
  '$timeout',
  'FilterService',
  'TaskService',
  'TemplateService',
  'AuthDataService',
  MyApprovalTaskListPaginated
]);
